import React, { useEffect, useRef, useState } from "react";
import ModalWrapper from "../formFields/wrapperModal/modalWrapper";
import { Checkbox, DatePicker, Input, message } from "antd";
import moment from "moment";
import { useSelector } from "react-redux";
import TableLoader from "../Loader/tableLoader";
import { isNumberOnly } from "../../../utils/regex";

const InventoryModal = ({
  type,
  detail,
  setInventory,
  inventoryValues,
  errors,
  setErrors,
  success,
  inventoryFunction,
}) => {
  const [stockId, setStockId] = useState();
  const [variantCheckboxValues, setVariantCheckboxValues] = useState({});
  console.log("errorss", errors);
  const closeButtonRef = useRef(null);
  // useEffect(() => {
  //     if (success && closeButtonRef.current) {
  //         closeButtonRef.current.click(); // triggers Bootstrap modal close
  //     }
  // }, [success]);

  const { data: variants, loading } = useSelector(
    (state) => state.variantWithoutInventory,
  );
  useEffect(() => {
    if (variants?.length) {
        const checkboxValues = {};

        variants.forEach((variant) => {
            checkboxValues[variant.variantId] = {
                cashOnDeliveryStatus: !!variant.cashOnDeliveryStatus,
                isPreBookAble: !!variant.isPreBookAble,
                autoCancelAble: !!variant.autoCancelAble,
                isCancellable: !!variant.isCancellable,
            };
        });

        setVariantCheckboxValues(checkboxValues);
    }
}, [variants]);

  const handleInputChange = (field, value, variantId) => {
    console.log("first", field, value, variantId);
    const stringValue = value?.toString() ?? "";
    setInventory({
      ...inventoryValues,
      [field]: value,
      variantId,
    });
    setErrors({
      ...errors,
      [field]: value
        ? isNumberOnly(stringValue)
          ? ""
          : `${field
              .replace(/([A-Z])/g, " $1")
              .replace(/^./, (c) => c.toUpperCase())
              .trim()} is Invalid`
        : `${field
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (c) => c.toUpperCase())
            .trim()} is Mandatory`,
    });
  };

  const renderInput = (field, variant, extraProps = {}) => (
    <>
      <Input
        className={`renewInputs ${
          variant?.variantId === stockId && errors?.[field] ? "invalid" : ""
        }`.trim()}
        disabled={variant?.variantId !== stockId}
        defaultValue={
          field === "mrp"
            ? variant?.["price"]
            : field === "price"
              ? ""
              : inventoryValues?.[field] || variant?.[field]
        }
        maxLength={field === "hsnCode" ? 30 : undefined}
        style={field === "hsnCode" ? { width: "120px" } : undefined}
        onChange={(e) =>
          handleInputChange(
            field,
            field === "price" || field === "mrp"
              ? parseInt(e.target.value)
              : field === "minimumOrderQuantity"
                ? e.target.value
                  ? e.target.value
                  : "1"
                : e.target.value,
            variant.variantId,
          )
        }
        {...extraProps}
      />
      {variant?.variantId === stockId && errors?.[field] && (
        <small
          className="text-danger d-block text-center mt-1"
          style={{
            width: "100%",
            fontSize: "11px",
            wordBreak: "break-word",
            whiteSpace: "normal",
          }}
        >
          {errors[field]}
        </small>
      )}
    </>
  );

  const renderDatePicker = (field, variant, disabledDate) => (
    <>
      <DatePicker
        className={`renewInputs ${
          errors?.[field] && variant?.variantId === stockId ? "invalid" : ""
        }`.trim()}
        format="YYYY-MM-DD"
        disabled={variant?.variantId !== stockId}
        disabledDate={disabledDate}
        getPopupContainer={() =>
          document.getElementById("InventorymodalScrollable") || document.body
        }
        onChange={(value) => {
          console.log("Selected Date:", value);

          handleInputChange(
            field,
            value
              ? field === "estimatedDeliveryDate" ||
                field === "startDateForPreBook"
                ? value.utc().format("YYYY-MM-DDTHH:mm:ss")
                : moment(value?.$d).format("YYYY-MM-DDT18:29:59")
              : "",
            variant.variantId,
          );

          setErrors({
            ...errors,
            [field]: value
              ? ""
              : `${field.replace(/([A-Z])/g, " $1")} is Mandatory`,
          });
        }}
      />

      {variant?.variantId === stockId && errors?.[field] && (
        <small
          className="text-danger d-block text-center mt-1"
          style={{
            width: "100%",
            fontSize: "11px",
            wordBreak: "break-word",
            whiteSpace: "normal",
          }}
        >
          {errors[field]}
        </small>
      )}
    </>
  );

  // const renderCheckbox = (field, variant, extra = {}) => (
  //   <Checkbox
  //     disabled={variant?.variantId !== stockId || extra?.disabled}
  //     defaultChecked={inventoryValues?.[field]}
  //     onChange={(e) =>
  //       handleInputChange(field, e.target.checked, variant.variantId)
  //     }
  //   />
  // );

  //correct
  // const renderCheckbox = (field, variant, extra = {}) => (
  //   <Checkbox
  //     disabled={variant?.variantId !== stockId || extra?.disabled}
  //     checked={
  //       variant?.variantId === stockId
  //         ? !!inventoryValues?.[field]
  //         : !!variant?.[field]
  //     }
  //     onChange={(e) =>
  //       handleInputChange(field, e.target.checked, variant.variantId)
  //     }
  //   />
  // );

  const renderCheckbox = (field, variant, extra = {}) => (
    <Checkbox
        disabled={variant?.variantId !== stockId || extra?.disabled}
        checked={
            variantCheckboxValues?.[variant.variantId]?.[field] ?? false
        }
        onChange={(e) => {
            const value = e.target.checked;

            setVariantCheckboxValues((prev) => ({
                ...prev,
                [variant.variantId]: {
                    ...prev[variant.variantId],
                    [field]: value,
                },
            }));

            handleInputChange(
                field,
                value,
                variant.variantId
            );
        }}
    />
);

  return (
    <ModalWrapper
      name={`${type} Stock Details & Price`}
      tooltipText="Enter stock quantity, pricing, batch details, expiry date, and selling limits before adding the product to inventory."
      id="InventorymodalScrollable"
      extraClasses="modal-dialog-scrollable modal-xl"
    >
      <div className="align-items-center d-flex float-lg-left w-100 mb-1">
        <span className="font-size-lg font-weight-bolder m-0">Store :</span>
        <span className="font-size-md ml-2 text-muted">
          {inventoryValues?.inventoryName}
        </span>
      </div>

      <div className="align-items-center justify-content-between d-flex w-100 mb-4">
        <div>
          <span className="font-size-lg font-weight-bolder m-0">
            Product Name :
          </span>
          <span className="font-size-md ml-5 text-muted">
            {detail?.name?.en} - {detail?.productDetails?.brand?.name?.en}
          </span>
        </div>

        {/* <span className="font-size-md ml-5 text-muted">Maximum allowed Selling Limit is 10.</span> */}

        <div>
          <Checkbox
            onChange={(e) =>
              setInventory({
                ...inventoryValues,
                returnStatus: e.target.checked,
              })
            }
          >
            Returnable Item
          </Checkbox>
        </div>
      </div>

      {loading ? (
        <TableLoader />
      ) : (
        <div className="table-responsive Inventory-modals">
          <table className="table table-bordered text-center m-0" width="100%">
            <thead className="text-white bg-gray-700">
              <tr>
                <th nowrap="nowrap">Size/Model No.</th>
                <th nowrap="nowrap"> Product SKU</th>
                <th nowrap="nowrap"> Product MRP</th>
                <th nowrap="nowrap"> Batch Number</th>
                <th nowrap="nowrap"> HSN Code</th>
                <th nowrap="nowrap">Your Price</th>
                <th nowrap="nowrap">Stock Available</th>
                <th nowrap="nowrap">Min Order Quantity</th>
                <th nowrap="nowrap">Lot Expiration Date</th>
                <th nowrap="nowrap">Selling Limit</th>
                <th>Cash On Delivery</th>
                <th>PreBook</th>
                {inventoryValues?.isPreBookAble ? (
                  <>
                    {" "}
                    <th>PreBooking Amount</th>
                    <th nowrap="nowrap">Start Date For PreBook</th>
                    <th nowrap="nowrap">PreBooking Last Date</th>
                    <th nowrap="nowrap">Last Date For Full Payment</th>
                    <th>AutoCancellable</th>
                    <th>Cancellation Available</th>
                  </>
                ) : (
                  ""
                )}
                {inventoryValues?.isCancellable &&
                inventoryValues?.isPreBookAble ? (
                  <th nowrap="nowrap">Cancellation Date</th>
                ) : (
                  ""
                )}
                {inventoryValues?.isPreBookAble ? (
                  <th nowrap="nowrap">Estimated Stock Availability Date</th>
                ) : (
                  ""
                )}

                {inventoryValues?.isPreBookAble ? (
                  <th nowrap="nowrap">Estimated Delivery End Date</th>
                ) : (
                  ""
                )}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {variants?.length ? (
                variants.map((variant, index) => (
                  <tr key={variant.variantId}>
                    <td className="align-middle">
                      {variant?.variant || variant?.variantSize}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {variant?.sku}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {renderInput("mrp", variant)}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {renderInput("batchNumber", variant)}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {renderInput("hsnCode", variant, {
                        maxLength: 30,
                        style: { width: "120px" },
                      })}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {renderInput("price", variant)}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {renderInput("stock", variant)}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {renderInput("minimumOrderQuantity", variant)}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {renderDatePicker("expiryDate", variant)}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {renderInput("maxEligibleQuantity", variant, {
                        type: "number",
                        max: 10,
                      })}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {renderCheckbox("cashOnDeliveryStatus", variant, {
                        disabled: inventoryValues?.isPreBookAble,
                      })}
                    </td>
                    <td className="align-middle font-weight-bold">
                      {renderCheckbox("isPreBookAble", variant, {
                        disabled: inventoryValues?.cashOnDeliveryStatus,
                      })}
                    </td>

                    {inventoryValues?.isPreBookAble && (
                      <>
                        <td className="align-middle font-weight-bold">
                          {renderInput("preBookAmount", variant)}
                        </td>
                        <td className="align-middle font-weight-bold">
                          {renderDatePicker(
                            "startDateForPreBook",
                            variant,
                            (current) => moment().add(-1, "days") >= current,
                          )}
                        </td>
                        <td className="align-middle font-weight-bold">
                          {renderDatePicker(
                            "lastDateForPreBook",
                            variant,
                            (current) =>
                              current <=
                              moment(inventoryValues?.startDateForPreBook),
                          )}
                        </td>
                        <td className="align-middle font-weight-bold">
                          {renderDatePicker(
                            "lastDateForFullPayment",
                            variant,
                            (current) =>
                              current <
                              moment(inventoryValues?.lastDateForPreBook),
                          )}
                        </td>
                        <td className="align-middle font-weight-bold">
                          {renderCheckbox("autoCancelAble", variant)}
                        </td>
                        <td className="align-middle font-weight-bold">
                          {renderCheckbox("isCancellable", variant)}
                        </td>
                      </>
                    )}

                    {inventoryValues?.isCancellable &&
                      inventoryValues?.isPreBookAble && (
                        <td className="align-middle font-weight-bold">
                          {renderDatePicker(
                            "cancellationDate",
                            variant,
                            (current) =>
                              current <=
                              moment(inventoryValues?.lastDateForPreBook),
                          )}
                        </td>
                      )}

                    {inventoryValues?.isPreBookAble && (
                      <td className="align-middle font-weight-bold">
                        {renderDatePicker(
                          "estimatedDeliveryDate",
                          variant,
                          (current) =>
                            current <=
                            moment(inventoryValues?.lastDateForPreBook),
                        )}
                      </td>
                    )}

                    {inventoryValues?.isPreBookAble && (
                      <td className="align-middle font-weight-bold">
                        {renderDatePicker(
                          "estimatedDeliveryEndDate",
                          variant,
                          (current) =>
                            current <=
                            moment(inventoryValues?.estimatedDeliveryDate),
                        )}
                      </td>
                    )}

                    <td className="align-middle font-weight-bold">
                      <i
                        className="flaticon-edit icon-md text-dark font-weight-bold mr-5 cursor-pointer"
                        // onClick={() => {
                        //   setStockId(variant.variantId);
                        //   setInventory({
                        //     ...inventoryValues,
                        //     mrp: variant.price,
                        //   });
                        // }}
                        onClick={() => {
                          setStockId(variant.variantId);

                          setInventory({
                            ...inventoryValues,
                            variantId: variant.variantId,
                            mrp: variant.price,
                            cashOnDeliveryStatus:
                              !!variant.cashOnDeliveryStatus,
                            isPreBookAble: !!variant.isPreBookAble,
                            autoCancelAble: !!variant.autoCancelAble,
                            isCancellable: !!variant.isCancellable,
                          });
                        }}
                      ></i>
                      <button
                        type="button"
                        data-dismiss={success ? "modal" : ""}
                        aria-label={success ? "Close" : ""}
                        ref={closeButtonRef} // <-- attach the ref unconditionally
                        className="all_bottom_buttons px-5 py-2 radius-0"
                        onClick={(e) => {
                          e.preventDefault();

                          const {
                            price,
                            hsnCode,
                            maxEligibleQuantity,
                            stock,
                            expiryDate,
                            preBookAmount,
                            startDateForPreBook,
                            lastDateForPreBook,
                            lastDateForFullPayment,
                            estimatedDeliveryDate,
                            estimatedDeliveryEndDate,
                            isCancellable,
                            cancellationDate,
                          } = inventoryValues;

                          // Mandatory validation
                          if (
                            !hsnCode ||
                            !maxEligibleQuantity ||
                            !stock ||
                            !price ||
                            !expiryDate
                          ) {
                            setErrors({
                              ...errors,
                              hsnCode: !hsnCode ? "HSN Code is Mandatory" : "",
                              maxEligibleQuantity: !maxEligibleQuantity
                                ? "Max Eligible Quantity is Mandatory"
                                : "",
                              stock: !stock ? "Stock is Mandatory" : "",
                              price: !price ? "Price is Mandatory" : "",
                              expiryDate: !expiryDate
                                ? "Expiry Date is Mandatory"
                                : "",
                            });
                            return;
                          }

                          // Prebook validation
                          if (inventoryValues?.isPreBookAble) {
                            if (
                              !preBookAmount ||
                              !startDateForPreBook ||
                              !lastDateForPreBook ||
                              !lastDateForFullPayment ||
                              !estimatedDeliveryDate ||
                              !estimatedDeliveryEndDate ||
                              (isCancellable && !cancellationDate)
                            ) {
                              setErrors({
                                ...errors,
                                preBookAmount: !preBookAmount
                                  ? "Pre Book Amount is Mandatory"
                                  : "",
                                startDateForPreBook: !startDateForPreBook
                                  ? "Start Date For PreBook is Mandatory"
                                  : "",
                                lastDateForPreBook: !lastDateForPreBook
                                  ? "Last Pre Book Date is Mandatory"
                                  : "",
                                lastDateForFullPayment: !lastDateForFullPayment
                                  ? "Full Payment Date is Mandatory"
                                  : "",
                                estimatedDeliveryDate: !estimatedDeliveryDate
                                  ? "Delivery Date is Mandatory"
                                  : "",
                                estimatedDeliveryEndDate:
                                  !estimatedDeliveryEndDate
                                    ? "Estimated Delivery End Date is Mandatory"
                                    : "",
                                cancellationDate:
                                  isCancellable && !cancellationDate
                                    ? "Cancellation Date is Mandatory"
                                    : "",
                              });
                              return;
                            }
                          }

                          inventoryFunction();
                        }}
                        // onClick={(e) => {
                        //   e.preventDefault();
                        //   const {
                        //     preBookAmount,
                        //     lastDateForPreBook,
                        //     lastDateForFullPayment,
                        //     estimatedDeliveryDate,
                        //     isCancellable,
                        //     cancellationDate,
                        //     price,
                        //     hsnCode,
                        //     maxEligibleQuantity,
                        //     stock,
                        //     expiryDate,
                        //   } = inventoryValues;

                        //   if (
                        //     hsnCode &&
                        //     maxEligibleQuantity &&
                        //     stock &&
                        //     price &&
                        //     expiryDate
                        //   ) {
                        //     inventoryFunction();
                        //   } else {
                        //     setErrors({
                        //       ...errors,
                        //       hsnCode: !hsnCode ? "HSN Code is Mandatory" : "",
                        //       maxEligibleQuantity: !maxEligibleQuantity
                        //         ? "Max Eligible Quantity is Mandatory"
                        //         : "",
                        //       stock: !stock ? "Stock  is Mandatory" : "",
                        //       price: !price ? "Price is Mandatory" : "",
                        //       expiryDate: !expiryDate
                        //         ? "Expiry Date is Mandatory"
                        //         : "",
                        //     });
                        //   }

                        //   if (inventoryValues?.isPreBookAble) {
                        //     if (
                        //       preBookAmount &&
                        //       lastDateForPreBook &&
                        //       lastDateForFullPayment &&
                        //       estimatedDeliveryDate &&
                        //       (!isCancellable || cancellationDate)
                        //     ) {
                        //       if (parseInt(preBookAmount) > parseInt(price)) {
                        //         message.error(
                        //           "Pre-booking Amount can not be more than your price",
                        //         );
                        //       } else {
                        //         inventoryFunction();
                        //       }
                        //     } else {
                        //       setErrors({
                        //         ...errors,
                        //         preBookAmount: preBookAmount
                        //           ? ""
                        //           : "Pre Book Amount is Mandatory",
                        //         lastDateForPreBook: lastDateForPreBook
                        //           ? ""
                        //           : "Last Pre Book Date is Mandatory",
                        //         lastDateForFullPayment: lastDateForFullPayment
                        //           ? ""
                        //           : "Full Payment Date is Mandatory",
                        //         estimatedDeliveryDate: estimatedDeliveryDate
                        //           ? ""
                        //           : "Delivery Date is Mandatory",
                        //         cancellationDate: cancellationDate
                        //           ? ""
                        //           : "Cancellation Date is Mandatory",
                        //       });
                        //     }
                        //   } else {
                        //     inventoryFunction();
                        //   }
                        // }}
                      >
                        Save
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={13} className="text-center">
                    No Variant Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </ModalWrapper>
  );
};

export default InventoryModal;
